export const EXSBOPERATION_DELETE_RESET = 'EXSBOPERATION_DELETE_RESET'
export const EXSBOPERATION_DELETE_SET_ERROR = 'EXSBOPERATION_DELETE_SET_ERROR'
export const EXSBOPERATION_DELETE_SET_DELETED = 'EXSBOPERATION_DELETE_SET_DELETED'
export const EXSBOPERATION_DELETE_TOGGLE_LOADING = 'EXSBOPERATION_DELETE_TOGGLE_LOADING'
